module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/document-framework-43.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/document-framework.md
// module id = 745
// module chunks = 444